// @flow

import { SelectProps } from 'antd/lib/select';
import React from 'react';

import { thirdPartyEmployeeApi } from '../../lib/api';
import type { Company } from '../../lib/types';
import AutocompleteSelect from './AutocompleteSelect';

export default (selectProps: SelectProps) => (
  <AutocompleteSelect
    placeholder="Выберите компанию"
    fetch={async params => {
      return await thirdPartyEmployeeApi.fetchCompanies({
        isArchived: false,
        isDeleted: false,
        ...params
      });
    }}
    fetchSingle={thirdPartyEmployeeApi.getCompany}
    notFoundText="Юридические лица не найдены"
    renderOption={(company: Company, Option) => (
      <Option key={company.id} value={company.id} company={company}>
        {company.name}{' '}
        {(company.inn || company.kpp) &&
          `(${company.inn ? `ИНН: ${company.inn}; ` : ''} ${
            company.kpp ? `КПП: ${company.kpp}` : ''
          })`}
      </Option>
    )}
    {...selectProps}
  />
);
